export const enum valorMeses {

    JAN = 1,
    FEV = 2,
    MAR = 3,
    ABR = 4,
    MAI = 5,
    JUN = 6,
    JUL = 7,
    AGO = 8,
    SET = 9,
    OUT = 10,
    NOV = 11,
    DEZ = 12,
    DECIMO13 = 13,
}


export class MesesEnum {

    public static values = [
        { label: 'Jan', value: valorMeses.JAN },
        { label: 'Fev', value: valorMeses.FEV },
        { label: 'Mar', value: valorMeses.MAR },
        { label: 'Abr', value: valorMeses.ABR },
        { label: 'Mai', value: valorMeses.MAI },
        { label: 'Jun', value: valorMeses.JUN },
        { label: 'Jul', value: valorMeses.JUL },
        { label: 'Ago', value: valorMeses.AGO },
        { label: 'Set', value: valorMeses.SET },
        { label: 'Out', value: valorMeses.OUT },
        { label: 'Nov', value: valorMeses.NOV },
        { label: 'Dez', value: valorMeses.DEZ },
        { label: '13º', value: valorMeses.DECIMO13},
    ]

    public static getDescricao = (id: number) => {
        let descricao = '';
        for (const key in MesesEnum.values) {
            if (id === MesesEnum.values[key].value) {
                descricao = MesesEnum.values[key].label;
                break;
            }
        }
        return descricao;
    };

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/dominios/enum/meses.enum.ts